import React from "react";
import milk from "../assets/milkImageForHome.jpg";
import Login from "./Login";

const Home = () => {
    return (
        <div
            className="min-h-screen bg-cover bg-center bg-no-repeat font-[Inter] relative overflow-hidden"
            style={{ backgroundImage: `url(${milk})` }}
        >
            {/* Overlay — FIXED: pointer-events-none prevents blocking clicks */}
            <div className="absolute inset-0 bg-white/50 backdrop-blur-[1px] z-10 pointer-events-none" />

            {/* Main Content */}
            <div
                className="relative z-20 min-h-screen px-6 md:px-14 lg:px-24 
                           flex flex-col md:flex-row items-center justify-center md:justify-between 
                           gap-10 md:gap-0"
            >
                {/* LEFT SIDE */}
                <div className="md:w-1/2 text-center md:text-left space-y-4">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#0F172A] leading-snug">
                        Smart & Accurate <br className="hidden md:block" />
                        Milk Testing System
                    </h1>

                    <p className="text-base sm:text-lg md:text-xl text-[#384454] max-w-lg mx-auto md:mx-0">
                        Precise FAT & SNF analysis powered by automated milk testing
                        technology for dairy collection centers.
                    </p>
                </div>

                {/* RIGHT — LOGIN */}
                {/* RIGHT SIDE — LOGIN COMPONENT */}
                <div className="md:w-1/2 flex items-center justify-center relative z-[9999] pointer-events-auto w-full">
                    <Login />
                </div>

            </div>

            {/* Wave Footer */}
            <div className="absolute bottom-0 left-0 w-full z-0 pointer-events-none">
                <svg
                    viewBox="0 0 1440 320"
                    className="w-full"
                    preserveAspectRatio="none"
                >
                    <path
                        fill="url(#blueGradient)"
                        d="M0,224L40,218.7C80,213,160,203,240,213.3C320,224,400,256,480,261.3C560,267,640,245,720,218.7C800,192,880,160,960,165.3C1040,171,1120,213,1200,234.7C1280,256,1360,256,1400,256L1440,256V320H0Z"
                    ></path>

                    <defs>
                        <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" stopColor="#0A2A88" />    {/* Dark royal blue */}
                            <stop offset="100%" stopColor="#0F3BCF" />  {/* Medium deep blue */}
                        </linearGradient>

                    </defs>
                </svg>
            </div>

        </div>
    );
};

export default Home;
